import React, { useRef } from 'react';

import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';

import '@splidejs/react-splide/css';
import ASSETS from '../../assets';

const CONFIG = [
  {
    img: ASSETS.CEO,
    name: 'Aiman Zahra',
    post: 'Founder & CEO',
    about:
      'Aiman began her journey with an LL.B, followed by a deep involvement in human rights advocacy. Her work has taken her from grassroots legal aid programs to prominent organizations, where she has been instrumental in shaping policies and practices to better serve those in need. With more than five years of experience in law and human rights, she has witnessed the numerous obstacles individuals face when trying to access legal aid, especially those from underrepresented communities. These challenges inspired her to envision this platform that would break down these barriers by providing a seamless platform where anyone, regardless of their location, can easily seek legal consultation. Her goal is to make legal support more accessible, bridging the gap between those in need and the legal assistance they deserve.',
  },
  {
    img: ASSETS.sabzwari,
    name: 'Syed Qamar Hussain Sabzwari',
    post: 'Senior Advisor',
    about: `With over 14 years of experience in the legal field and having led numerous key committees, including the Inter-Provincial Bar Council Relations, Disciplinary, and Human Rights Committees, Barrister Sabzwari has provided valuable endorsements for this platform. His insights have been crucial in enhancing the platform's accessibility to the general public and in identifying features that will benefit legal professionals. Additionally, his active involvement in human rights advocacy has been instrumental in shaping the platform to better serve individuals with limited resources in accessing legal services.

Barrister Sabzwari earned his LL.B (Honors) from the University of London and completed the Bar Vocational Course (BVC) at the University of the West of England, Bristol called to the Bar by the Honourable Society of Lincoln’s Inn, London.`,
  },
  {
    img: ASSETS.asif_mehmood,
    name: 'Asif Mehmood Cheema',
    post: 'Senior Advisor',
    about: `Asif Mehmood Cheema is an expert legal professional currently serving as an Additional Advocate General. He is an Advocate of the High Court and a member of the Punjab Bar Council with a solid educational foundation, holding a B.A and LL.B, His extensive experience and commitment to justice have made him a trusted advocate in high-stakes legal matters. He continues to play a crucial role in representing the government and upholding the rule of law in his jurisdiction.`,
  },
  {
    img: ASSETS.ammaz_sajid,
    name: 'Ammaz Sajid',
    post: 'Legal Advisor',
    about: `Ammaz’s extensive background in both business administration and legal services has played a pivotal role in the creation and evolution of this platform. His deep understanding of our legal system has been invaluable in developing the application's workflow. This expertise has not only ensured that the platform aligns with legal standards but also that it remains highly intuitive and user-friendly. Ammaz's ability to bridge the gap between complex legal requirements and practical, user-centered design has been a driving force behind the platform's success and usability.`,
  },
  {
    img: ASSETS.abdulhanan,
    name: 'Abdul Hannaan Salik',
    post: 'CPO',
    about: `With extensive experience in IT projects, Hannaan has played a vital role in connecting users, legal professionals, and the development team. His expertise in understanding and interpreting the diverse needs of these stakeholders has been crucial in shaping the platform. Hannaan has  gathered and analyzed requirements from both end users and legal experts, ensuring that every detail is captured. He then translated these requirements into precise technical specifications, guiding the development team in building a robust, user-friendly platform tailored to the unique challenges of the legal industry.`,
  },
];

const Slider = () => {
  const splide = useRef(null);

  const goToPrevSlide = () => {
    if (splide.current) {
      // @ts-ignore
      splide.current.splide.go('<');
    }
  };

  const goToNextSlide = () => {
    if (splide.current) {
      // @ts-ignore
      splide.current.splide.go('>');
    }
  };

  return (
    <div className='lg:mt-[68px] md:mt-12 '>
      <div className='w-full bg-l-light-grey rounded-[24px] mt-10 relative'>
        <Splide
          hasTrack={false}
          ref={splide}
          options={{
            arrows: false,
            pagination: false,
            type: 'loop',
            autoplay: true,
          }}
        >
          <SplideTrack>
            {CONFIG.map((item, i) => (
              <SplideSlide key={i}>
                <div className='flex lg:flex-row flex-col 2xl:items-start lg:items-center xl:gap-8 gap-6 relative md:p-6 p-5 lg:pb-5 pb-[80px]'>
                  <img
                    src={ASSETS.quotes}
                    className='absolute top-[40px] right-[40px]'
                    alt=''
                  />
                  <img
                    src={item.img}
                    className='h-full lg:max-w-[412px] max-w-[100vw] w-full'
                    alt=''
                  />
                  <div className='lg:mt-[32px] mt-5'>
                    <div className='flex items-center gap-4'>
                      <div>
                        <p className='text-2xl text-l-primary font-semibold'>
                          {item.name}
                        </p>
                        <p className='text-base font-medium text-l-primary'>
                          {item.post}
                        </p>
                      </div>
                    </div>
                    <p className='lg:text-lg text-base text-l-primary mt-[32px] pr-10 '>
                      {item.about}
                    </p>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </SplideTrack>
        </Splide>
        <div className='flex items-center gap-[6px] absolute right-10 bottom-6'>
          <button
            onClick={goToPrevSlide}
            className='h-12 w-[70px] bg-white grid place-items-center rounded-[100px]'
          >
            <img src={ASSETS.chevronRight} className='rotate-180' alt='' />
          </button>
          <button
            onClick={goToNextSlide}
            className='h-12 w-[70px] bg-white grid place-items-center rounded-[100px]'
          >
            <img src={ASSETS.chevronRight} alt='' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slider;
